import React from 'react';
import PropTypes from 'prop-types';
import {
  ForgeButton,
  ForgeMenu,
  ForgeSplitButton,
} from '@tylertech/forge-react';

const SplitButton = ({title, splitButtonOptions}) => {
  return (
    <ForgeSplitButton variant="raised" theme="primary">
      <ForgeButton variant="raised">
        {title}
      </ForgeButton>
      <ForgeMenu
        options={splitButtonOptions}
        on-forge-menu-select={(e) => splitButtonOptions.find(option => option.value === e.detail.value).onClick()}
      >
        <ForgeButton
          aria-label="Show menu"
          popover-icon
          variant="raised"
        ></ForgeButton>
      </ForgeMenu>
    </ForgeSplitButton>
  );
};

SplitButton.propTypes = {
  title: PropTypes.string,
  splitButtonOptions: PropTypes.array,

};

export default SplitButton;
